/**
 * Directive: File Input
 *
 * AngularJS directive to help watch a file input for changes,
 * watches for two-way changes. Note that this provides an Array of files.
 *
 */
angular.module('acme.common.directive.fileInput', [])
  .directive('fileInput', fileInput);

function fileInput() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function ($scope, $element, attrs, ngModel) {

      $element.bind('change', function (event) {
        ngModel.$setViewValue(event.target.files);
        $scope.$apply();
      });

      $scope.$watch(function () {
        return ngModel.$viewValue;
      }, function (value) {
        if (!value) {
          $element.val('');
        }
      });
    }
  };
}
